import { rupee } from "@/lib/constants";
import { fmtTs } from "@/components/Timeline";
import { Check, X, Clock } from "lucide-react";

// Customer-facing refund progress: Requested → Approved → Refunded (or Rejected with reason).
export function RefundTracker({ r }) {
    const rejected = r.status === "REJECTED";
    const steps = [
        { k: "REQUESTED", l: "Requested", at: r.created_at, note: r.reason },
        rejected
            ? { k: "REJECTED", l: "Not approved", at: r.decided_at, note: r.decision_reason }
            : { k: "APPROVED", l: "Approved", at: r.decided_at, note: r.decision_reason },
        ...(rejected ? [] : [{ k: "PROCESSED", l: "Refunded to you", at: r.processed_at, note: r.utr ? `Bank ref ${r.utr} · may take 3–5 working days to reflect` : "Our accounts team will transfer it" }]),
    ];
    const reached = (i) => i === 0 || (i === 1 && ["APPROVED", "REJECTED", "PROCESSED"].includes(r.status)) || (i === 2 && r.status === "PROCESSED");
    return (
        <div data-testid={`refund-tracker-${r.refund_id}`} className="rounded-2xl border border-navy/10 bg-white p-4">
            <div className="flex items-start justify-between gap-2">
                <div>
                    <p className="font-heading font-bold text-navy">{rupee(r.amount)} refund</p>
                    <p className="text-[11px] text-navy/45">{r.refund_id} · {r.booking_ref}{r.service_name ? ` · ${r.service_name}` : ""}</p>
                </div>
                <span data-testid={`refund-tracker-status-${r.refund_id}`} className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${rejected ? "bg-rose-50 text-rose-700" : r.status === "PROCESSED" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                    {rejected ? "Not approved" : r.status === "PROCESSED" ? "Refunded" : r.status === "APPROVED" ? "Approved" : "Under review"}
                </span>
            </div>
            <ol className="mt-3 space-y-3">
                {steps.map((s, i) => {
                    const done = reached(i);
                    const bad = s.k === "REJECTED" && done;
                    return (
                        <li key={s.k} className="flex gap-3">
                            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${bad ? "bg-rose-500 text-white" : done ? "bg-emerald-500 text-white" : "border-2 border-navy/15 text-navy/30"}`}>
                                {bad ? <X size={12} /> : done ? <Check size={12} /> : <Clock size={10} />}
                            </span>
                            <div className="min-w-0 flex-1">
                                <p className={`text-sm font-semibold ${done ? "text-navy" : "text-navy/40"}`}>{s.l}{done && s.at ? <span className="ml-1.5 text-[11px] font-normal text-navy/40">{fmtTs(s.at)}</span> : null}</p>
                                {done && s.note && <p className="text-xs text-navy/55">{s.note}</p>}
                            </div>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
}
